export const customFieldsSelectors = {
  customFieldError: state => state.customFields.single.errors,
  getCustomFieldsListData: state => state.customFields.list.results,
  isFetchingCustomFieldsListData: state => state.customFields.list.isFetching,
  isPendingCustomField: state => state.customFields.single.isPending,
};
